import { DetailedStudy } from '$app-web/types';

import { axios } from '../../axios';
import { Endpoints } from '../constant';

export async function fetchStudyDetails(studyId: number) {
    try {
        const { status, data } = await axios.get<DetailedStudy>(`${Endpoints.Participation}/${studyId}/`);

        if (status === 200) {
            return data;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}
